import { FormGroup, IOptionProps, RadioGroup } from '@blueprintjs/core'
import React, { SFC } from 'react'

import { isEmpty, isPresent } from '../../app/shared'

import { FieldAdapterProps, RadioProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

export type Props = FieldAdapterProps<RadioProps>

const RadioGroupAdapter: SFC<Props> = ({
  input,
  meta,
  label,
  disabled,
  inline,
  translate = identity,
  helperText,
  required,
  intent,
  options,
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)
  const intentType = getIntent(meta, intent)

  return (
    <FormGroup
      className={labelInfo ? 'required' : ''}
      helperText={helperTextMessage}
      label={labelText}
      labelFor={id}
      labelInfo={labelInfo}
      disabled={disabled}
      intent={intentType}
    >
      <RadioGroup
        disabled={disabled}
        inline
        options={options}
        selectedValue={input.value}
        onChange={handleOnChange(input, options)}
      />
    </FormGroup>
  )
}

const handleOnChange = (input: any, options?: IOptionProps[]) => (event: React.FormEvent<HTMLInputElement>) => {
  // get type of the first option in incoming options array (or string if its empty)
  const typeofValue = (isPresent(options) && !isEmpty(options) && typeof options[0].value) || 'string'

  // use that type to "preserve" value type that is propagated by input.onChange callback
  // (if value is number, and option value is number, keep it this way, do not "switch" to string)
  const value = typeofValue === 'number' ? Number(event.currentTarget.value) : event.currentTarget.value

  input.onChange(value)
}

export { RadioGroupAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/radio-group-adapter.tsx